import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { editSettings, getSettingInfo, addSetting, getHolidays, checkSupervisor } from 'api/Attendance';
import myMap from './map';
import framework from '_c/framework';
import org from '_c/organization';
import SelectSch from './select-scheduling';
import CommonHolidayModal from './common-holiday-modal';
import { axiosRequest } from '@/util/axios-request';

// 最大值限制
import '@/views/payroll/directive.js';

// 规则类型
var typeRules = [
// 固定班制
{
  value: '1',
  key: '1863',
  warn: '1865'
},
// 不固定班制
{
  value: '2',
  key: '1864',
  warn: '1866'
},
// 排班
{
  value: '4',
  key: '1728',
  warn: '1733'
},
// 不需要打卡
{
  value: '3',
  key: '554',
  warn: '1867'
}];
// 表格数据格式化
// 一周翻译
var weekArr = ['559', '560', '561', '562', '563', '564', '565'];
// 表格数据 循环生成
var tableData = function tableData(self) {
  return weekArr.map(function (item, index) {
    return {
      label: self.$t(item),
      value: index + 1,
      start_time: '',
      end_time: ''
    };
  });
};
var supervisorStaffIds = function supervisorStaffIds(rule, value, callback) {
  if (!value.length) {
    return callback(new Error(rule.message));
  } else {
    callback();
  }
};
export default {
  props: {
    type: {
      type: Number,
      default: false
    },
    p: {
      type: String,
      default: ''
    }
  },
  components: {
    myMap: myMap,
    org: org,
    framework: framework,
    SelectSch: SelectSch,
    CommonHolidayModal: CommonHolidayModal
  },
  data: function data() {
    var _this = this,
      _ref;
    var areaSetting = function areaSetting(rule, value, callback) {
      var area_setting = _this.form.area_setting;
      if (!Array.isArray(area_setting) || area_setting.length < 1) {
        callback(new Error(_this.$t('858')));
      } else {
        callback();
      }
    };
    // 公共假期校验
    var holidaySettingValid = function holidaySettingValid(rule, value, callback) {
      var checked = _this.checked;
      if (checked && value || !checked) return callback();
      callback(new Error(_this.$t('221')));
    };
    // 结束时间校验
    var shiftValid = function shiftValid(rule, value, callback) {
      var isSameTime = _this.isNextDay.isSameTime;
      if (isSameTime) callback(new Error(_this.$t('1919')));
      return callback();
    };
    return _ref = {
      // 考勤规则枚举
      typeRules: typeRules,
      // 所选假期名称
      holidayTitle: '',
      // 周翻译
      weekArr: weekArr,
      // 默认时间
      defaultDate: {
        start: new Date('', '', '', '9', '30', '0'),
        end: new Date('', '', '', '18', '0', '0')
      },
      orgVisible: false,
      orgVisibleLead: false,
      tableData: tableData(this),
      weekInfo: [],
      // 选中周信息
      // 法定节假日
      checked: null,
      holidaySettings: [],
      //公共假日options
      form: {
        type: '1',
        department_id: [],
        staff_info_ids: [],
        supervisor_staff_list: [],
        supervisor_staff_ids: [],
        off_min_later: '',
        on_min_ago: '',
        half_day_hour: '',
        one_day_hour: '',
        shift_start: '09:00',
        //打卡时段开始时间
        shift_end: '18:00',
        // 打卡时段结束时间
        is_on_face: false,
        // 是否开启人脸识别打卡，0不开启，1开启
        face_method: 2,
        // 人脸打卡方式，0不开启，1人脸打卡，2人脸打卡+活体检测
        week_info: [],
        // 工作日
        holiday_setting_id: '',
        // 公共假日ID
        out_range_hide_address: '2',
        // 允许外勤员工隐藏具体地点 1 允许 2 不允许
        is_business: undefined,
        is_business_click: undefined
      },
      rules: {
        name: [{
          required: true,
          message: this.$t('547')
        }],
        supervisor_staff_ids: [{
          validator: supervisorStaffIds,
          required: true,
          message: this.$t('221'),
          trigger: ['blur', 'change']
        }],
        change_type: [{
          required: true,
          message: this.$t('535')
        }],
        out_range: [{
          required: true,
          message: this.$t('221')
        }],
        off_min_later: [{
          required: true,
          message: this.$t('90')
        }],
        on_min_ago: [{
          required: true,
          message: this.$t('90')
        }],
        half_day_hour: [{
          required: true,
          message: this.$t('90')
        }],
        one_day_hour: [{
          required: true,
          message: this.$t('90')
        }],
        shift_end: [{
          validator: shiftValid
        }],
        shift_start: [{
          validator: shiftValid
        }],
        area_setting: [{
          validator: areaSetting,
          trigger: 'change'
        }],
        holiday_setting_id: [{
          validator: holidaySettingValid
        }],
        face_method: [{
          required: true,
          message: this.$t('1353')
        }],
        is_on_face: [{
          required: true,
          message: this.$t('1353')
        }],
        out_range_hide_address: [{
          required: true,
          message: this.$t('1353')
        }],
        is_business: [{
          required: true,
          message: this.$t('221')
        }],
        is_business_click: [{
          required: true,
          message: this.$t('221')
        }]
      },
      week: [],
      loading: false,
      options: [],
      radio: 3,
      value: ''
    }, _defineProperty(_ref, "holidayTitle", [{}]), _defineProperty(_ref, "area", []), _defineProperty(_ref, "staffList", []), _defineProperty(_ref, "default_shift", {}), _defineProperty(_ref, "default_supervisor", {}), _ref;
  },
  computed: {
    isDefault: function isDefault() {
      var s = !(this.form.is_default && this.form.is_default == 1);
      if (!s) this.form.change_type = 1;
      return s;
    },
    // 是否展示次日 是否提示开始时间不能等于结束时间
    // 当结束时间小于开始时间则显示次日
    isNextDay: function isNextDay() {
      // '19:00' '15:32'
      var _this$form = this.form,
        shift_start = _this$form.shift_start,
        shift_end = _this$form.shift_end;
      var result = {
        isViewNextDay: false,
        isSameTime: false
      };
      if (!shift_start || !shift_end) return result;
      var end = parseInt(shift_end.replace(':', ''));
      var start = parseInt(shift_start.replace(':', ''));
      // 判断结束时间是否小于开始时间
      result.isViewNextDay = end < start;
      // 判断结束时间是否等于开始时间
      result.isSameTime = end === start;
      return result;
    }
  },
  watch: {
    visible: function visible(v) {
      if (!v) {
        this.tableData = tableData(this);
      }
    }
  },
  methods: {
    // 查看
    handleViewDetail: function handleViewDetail() {
      var _this2 = this;
      this.$refs.viewHoliday.visible = true;
      // 编辑获取详情
      this.$nextTick(function () {
        _this2.$refs.viewHoliday.holidayDetail(_this2.form.holiday_setting_id);
      });
    },
    // 表格默认选中
    tableSelect: function tableSelect() {
      var _this3 = this;
      this.tableData.forEach(function (row) {
        if (row.checked) {
          _this3.$refs.table && _this3.$refs.table.toggleRowSelection(row, true);
        }
      });
      this.handlerWorkDays();
    },
    // 工作日默认选中
    handlerWorkDays: function handlerWorkDays() {
      this.weekInfo = this.form.week_info.map(function (item) {
        return Number(item.day);
      });
    },
    changeRadio: function changeRadio(val) {
      var weekInfo = this.form.week_info;
      this.week = weekInfo.map(function (item) {
        return Number(item.day);
      });
      if (val === '1') this.tableSelect();
      if (val === '3' && this.type === 1) this.week = [1, 2, 3, 4, 5];
      // 自由班制的打卡时段设置：该时段为可以进行上下班打卡时段，而非班次时间。时段默认值为9-18，
      if (val === '2') {
        this.form.shift_start = '09:00';
        this.form.shift_end = '18:00';
      }
    },
    init: function init(obj) {
      var _this4 = this;
      // 1 新建 2编辑
      if (this.type === 2) {
        var params = JSON.parse(JSON.stringify(obj));
        // 获取详情
        this.handleGetSettingInfo(params);
      } else {
        // 默认选中周一到周五
        this.tableData = this.tableData.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            start_time: undefined,
            end_time: undefined,
            checked: item.value < 6 ? true : false
          });
        });
        this.$nextTick(function () {
          return _this4.tableSelect();
        });
        // 获取公共假期列表
        // getHolidays().then(res => {
        //   this.holidaySettings = res.data
        //   // 默认选中的假期
        //   this.handleHolidayGet()
        // })
        axiosRequest({
          url: '/web/attendance/addSettingInfo',
          method: 'GET'
        }).then(function (res) {
          _this4.holidaySettings = res.data.holidays;
          // 默认选中的假期
          _this4.handleHolidayGet();
          // 默认触发班次选中操作
          _this4.schSelect(res.data.default_shift);
          _this4.default_shift = res.data.default_shift || {};
          _this4.default_supervisor = JSON.parse(JSON.stringify(res.data.default_supervisor || {}));
          _this4.form.supervisor_staff_list = res.data.default_supervisor ? [res.data.default_supervisor] : [];
          _this4.form.supervisor_staff_ids = res.data.default_supervisor ? [res.data.default_supervisor.staff_id] : [];
        });
      }
      this.visible = true;
    },
    // 获取默认公共假期
    handleHolidayGet: function handleHolidayGet() {
      var selectedHoliday = this.holidaySettings.filter(function (item) {
        return item.is_selected;
      })[0];
      if (selectedHoliday) {
        this.form.holiday_setting_id = selectedHoliday.id;
      }
    },
    // 初始化表格数据渲染
    handleGetSettingInfo: function handleGetSettingInfo(params) {
      var _this5 = this;
      var msg = {
        id: params.id
      };
      getSettingInfo(msg).then(function (res) {
        // 获取假期列表
        _this5.holidaySettings = res.data.holiday_setting;
        // 默认选中的假期
        _this5.form = _objectSpread(_objectSpread({}, _this5.form), res.data);
        // 公共假期值
        _this5.handleHolidayGet();
        _this5.checked = !!(_this5.form.is_holiday && _this5.form.is_holiday === '1');
        // 打卡日
        var weekInfo = res.data.week_info;
        _this5.week = weekInfo.map(function (item) {
          return Number(item.day);
        });
        // 格式化表格数据
        _this5.tableData = _this5.tableData.map(function (item, index) {
          weekInfo.forEach(function (el) {
            if (Number(el.day) === item.value) {
              el.week = item.value;
              item = _objectSpread(_objectSpread({}, item), el);
              item.checked = true;
            }
          });
          return item;
        });
        // 打卡范围
        _this5.area = _this5.form.area_info || [];
        // 默认选中
        _this5.form.staff_info_ids = _this5.form.staff_list;
        _this5.form.supervisor_staff_ids = _this5.form.supervisor_staff_list;
        _this5.staffList = _this5.form.staff_list;
        // 班次表格默认选中
        _this5.$nextTick(function () {
          _this5.tableSelect();
        });
        // 人物数据选中
        var _this5$form = _this5.form,
          department_list = _this5$form.department_list,
          staff_list = _this5$form.staff_list,
          supervisor_staff_list = _this5$form.supervisor_staff_list;
        /**
         *  保存时所需参数
         *  department_id，staff_info_ids Examples[1,2,3]
         *  地理位置参数 area_setting
         */
        var area_info = _this5.form.area_info;
        area_info && (_this5.form.area_setting = area_info.map(function (item) {
          return {
            name: item.area_name,
            lng: item.area_lng,
            lat: item.area_lat,
            range: item.range
          };
        }));
        _this5.form.department_id = [];
        _this5.form.staff_info_ids = [];
        _this5.form.supervisor_staff_ids = [];
        /**
         *  组织架构选择组件所需格式 默认选中
         *  部门：department_id  和  department_name
         *  人员：staff_id 和  staff_name
         */
        _this5.form.department_list = department_list.map(function (item) {
          _this5.form.department_id.push(item.id);
          item.department_id = item.id;
          item.department_name = item.name;
          return item;
        });
        _this5.handleStaffList(staff_list, 'staff_info_ids', 'staff_list');
        _this5.handleStaffList(supervisor_staff_list, 'supervisor_staff_ids', 'supervisor_staff_list');
      });
    },
    handleStaffList: function handleStaffList(data, ids, list) {
      var _this6 = this;
      var staffs = [];
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this6.form[ids].push(item.id || item.staff_id);
          staffs.push({
            staff_id: item.staff_id || item.id,
            staff_name: item.staff_name || item.name,
            staff_name_en: item.staff_name_en,
            staff_name_secondary: item.staff_name_secondary,
            staff_name_th: item.staff_name_th || item.name,
            avatar_url: item.avatar_url,
            id: item.id,
            name: item.name
          });
        });
      }
      this.form[list] = staffs;
    },
    departSel: function departSel(a, b, c) {
      this.form.department_id = c;
    },
    showMap: function showMap() {
      this.$refs.map.visible = true;
    },
    get_table_row_unchcek_item: function get_table_row_unchcek_item(item) {
      return {
        checked: false,
        label: item.label,
        value: item.value,
        start_time: undefined,
        end_time: undefined
      };
    },
    get_table_row_checked_item: function get_table_row_checked_item(item) {
      var shift_obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _objectSpread(_objectSpread({}, item), {}, {
        checked: true,
        end_mark: shift_obj.end_mark,
        start_time: shift_obj.start,
        end_time: shift_obj.end,
        shift_name: shift_obj.name,
        shift_id: shift_obj.id
      });
    },
    // 当用户手动勾选全选 Checkbox 时触发的事件
    handleSelectAll: function handleSelectAll(selection) {
      var _this7 = this;
      var cb = selection.length === 0 ? this.get_table_row_unchcek_item : this.get_table_row_checked_item;
      this.tableData = this.tableData.map(function (item) {
        return selection.length === 0 ? cb(item) : cb(item, _this7.default_shift);
      });
      this.$nextTick(function () {
        _this7.tableSelect();
      });
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    handleSelect: function handleSelect(selection, row) {
      var _this8 = this;
      row.checked = !row.checked;
      var index = this.tableData.findIndex(function (item) {
        return item.value === row.value;
      });
      var value = row.checked ? this.get_table_row_checked_item(row, this.default_shift) : this.get_table_row_unchcek_item(row);
      this.$set(this.tableData, index, value);
      this.$nextTick(function () {
        var item = _this8.tableData[index];
        _this8.$refs.table.toggleRowSelection(item, item.checked);
      });
    },
    // 当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(selection) {
      this.form.week_info = selection;
    },
    addCloumn: function addCloumn() {
      this.holidayTitle.push({});
    },
    // 打开班次设置
    openSch: function openSch(params, row) {
      var id = row ? row.shift_id : this.default_shift.id;
      this.$refs.selectSch.updateCurrentShiftId(id);
      this.$refs.selectSch.init(params);
    },
    update_default_shfit: function update_default_shfit(value) {
      this.default_shift = value;
    },
    // 班次选中操作
    schSelect: function schSelect(params) {
      var _this9 = this;
      var index = params.index,
        start = params.start,
        end = params.end,
        name = params.name,
        id = params.id,
        end_mark = params.end_mark;
      // 只针对快捷设置的更改
      if (index === null) {
        this.update_default_shfit(params);
      }
      // 修改全部 index参数不存在时且不含有0则修改全部 反之相反
      if (!index && index !== 0) {
        this.form.shift_start = start;
        this.form.shift_end = end;
        this.form.end_mark = end_mark;
        this.tableData = this.tableData.map(function (item) {
          if (item.value < 6) {
            return _this9.get_table_row_checked_item(item, params);
          } else {
            return _this9.get_table_row_unchcek_item(item);
          }
        });
      } else {
        var item = this.tableData[index];
        this.$set(this.tableData, index, _objectSpread(_objectSpread({}, item), {}, {
          checked: true,
          start_time: start,
          end_time: end,
          shift_name: name,
          shift_id: id,
          end_mark: end_mark
        }));
      }
      this.$nextTick(function () {
        _this9.tableData.forEach(function (item) {
          if (item.checked) _this9.form.week_info.push(item);
        });
        _this9.tableSelect();
      });
    },
    changeMap: function changeMap(obj) {
      this.$set(this.form, 'area_setting', obj ? obj : this.form.area_setting);
      this.area = obj || [];
    },
    // 编辑群组保存请求
    handleEditSettings: function handleEditSettings() {
      var _this10 = this;
      var _this$form2 = this.form,
        one_day_hour = _this$form2.one_day_hour,
        half_day_hour = _this$form2.half_day_hour;
      if (Number(one_day_hour) < Number(half_day_hour)) {
        return this.$notify({
          title: this.$t('229'),
          message: this.$t('1401'),
          type: 'warning'
        });
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var _this10$form = _this10.form,
            type = _this10$form.type,
            week_info = _this10$form.week_info,
            week = _this10$form.week;
          var obj = week_info || [];
          var status = type === '1';
          /**
           *    根据考勤规则判断  form.type 不同的类型传不同的参数
           *    1. 规定打卡时间 则过滤没有打卡时间的
           *    2. 不限制打卡时间则可以选中 时间可不传
           *    3. 不需要打卡则不需要次想操作
           *    4. 排班
           */
          var arr = [];
          // 需要打卡则生成week_setting
          if (type === '1') {
            obj.map(function (item) {
              var msg = {
                week: item.value
              };
              var start = item.start_time;
              var end = item.end_time;
              var shift_id = item.shift_id;
              start && (msg.start = start.split(' ').slice(-1)[0]);
              end && (msg.end = end.split(' ').slice(-1)[0]);
              shift_id && (msg.shift_id = shift_id);
              msg.rest_end = item.rest_end;
              msg.rest_start = item.rest_start;
              if (status && start && end && shift_id || _this10.form.type === '2') arr.push(msg);
            });
          }
          if (type === '2' || type === '3') {
            arr = _this10.week.map(function (item) {
              return {
                week: item
              };
            });
          }
          // 不限制打卡时间
          _this10.form.is_holiday = _this10.checked ? 1 : 2;
          // 需要打卡则传递该打卡信息
          _this10.form.week_setting = arr;
          // 数组降纬
          if (_this10.form.staff_info_ids) {
            _this10.form.staff_info_ids = _this10.form.staff_info_ids.flat();
          }
          // 不需要打卡是则传递这些参数
          if (_this10.form.type && _this10.form.type === '3') {
            var msg = {
              name: _this10.form.name,
              department_id: _this10.form.department_id,
              staff_info_ids: _this10.form.staff_info_ids,
              supervisor_staff_ids: _this10.form.supervisor_staff_ids,
              type: _this10.form.type,
              change_type: _this10.form.change_type,
              is_holiday: _this10.form.is_holiday,
              week_setting: _this10.form.week_setting,
              shift_start: _this10.form.shift_start,
              shift_end: _this10.form.shift_end,
              half_day_hour: _this10.form.half_day_hour,
              one_day_hour: _this10.form.one_day_hour,
              id: _this10.form.id,
              holiday_setting_id: _this10.form.holiday_setting_id,
              is_business: _this10.form.is_business,
              is_business_click: _this10.form.is_business_click
            };
            _this10.form = msg;
          }
          var requestMethods = _this10.type === 1 ? addSetting : editSettings; // 编辑或新建接口
          var toTargetType = _this10.form.type === '4' ? 3 : 1; // 根据type来判断保存之后是否跳转到排班
          _this10.loading = true; // 防重复点击
          // 参数请求
          requestMethods(_this10.form).then(function (res) {
            _this10.$emit('doSubmit', {
              id: _this10.form.id || res.data.id
            }, toTargetType);
            _this10.$parent.handleGetAttendanceSettingList();
          }).finally(function () {
            return _this10.loading = false;
          });
        }
      });
    },
    leadStaffList: function leadStaffList() {
      var staffName = '';
      var list = this.form.supervisor_staff_list || [];
      if (list.length) {
        list.forEach(function (item, index) {
          if (list.length - 1 === index) {
            staffName += item.staff_name;
          } else {
            staffName += item.staff_name + ', ';
          }
        });
      }
      return staffName;
    },
    handleLeadDepart: function handleLeadDepart(params) {
      var _this11 = this;
      var ids = this.form.supervisor_staff_ids;
      var list = this.form.supervisor_staff_list;
      // 校验已选成员是否包含当前登录账号人员（当前登录账号为主管理员无须校验）
      checkSupervisor({
        supervisor_staff_ids: params.staffIds
      }).then(function (_ref2) {
        var data = _ref2.data;
        if (data && !data.check_result) {
          if (!params.staffIds.includes(_this11.default_supervisor.staff_id)) {
            _this11.$confirm(_this11.$t('2b876c04'), _this11.$t('229'), {
              confirmButtonText: _this11.$t('419'),
              cancelButtonText: _this11.$t('66'),
              type: 'warning'
            }).then(function () {
              _this11.form.supervisor_staff_ids = params.staffIds;
              _this11.form.supervisor_staff_list = params.staff_list;
              _this11.orgVisibleLead = false;
            }).catch(function () {
              _this11.form.supervisor_staff_ids = ids;
              _this11.form.supervisor_staff_list = list;
            });
          }
        } else {
          _this11.form.supervisor_staff_ids = params.staffIds;
          _this11.form.supervisor_staff_list = params.staff_list;
          _this11.orgVisibleLead = false;
        }
      });
    },
    // 选择成员
    handleSelectDepart: function handleSelectDepart(params) {
      this.form.department_id = this.formateList(params.dept_list, 'department_id');
      this.form.staff_info_ids = this.formateList(params.staff_list, 'staff_id');
      this.form.department_list = params.dept_list;
      this.form.staff_list = params.staff_list;
    },
    // 数据格式化
    formateList: function formateList(obj, key) {
      return obj.map(function (item) {
        return item[key];
      });
    }
  }
};